<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    // Kolla efter utm_source. Trafiken in bör komma från en annons i något nätverk.
    //
    const queryObj = this.$route.query;

    if (queryObj.hasOwnProperty('utm_source')) {
      sessionStorage.setItem('traffic_source', queryObj.utm_source);
    } else {
      sessionStorage.setItem('traffic_source', 'direct');
    }
  }
};
</script>
<style>
#app {
  user-select: none;
}
</style>
